import { observer } from 'mobx-react-lite';
import type { FC } from 'react';

import { Pagination } from 'components/Pagination';
import { useStore } from 'hooks/useStore';

const FavoritesPagination: FC<TFavoritesPaginationProps> = ({ className }) => {
  const {
    app: { locale },
    favorites,
  } = useStore();

  const handlePageChange = ({ selected }: { selected: number }) => {
    favorites.setPage(selected);
    favorites.updateLoads();
  };

  return (
    <Pagination
      className={className}
      disabled={false}
      initialPage={favorites.page}
      locale={locale}
      pageCount={favorites.totalPages}
      tooltip={false}
      onPageChange={handlePageChange}
    />
  );
};

export type TFavoritesPaginationProps = {
  className?: string;
};

const connected = observer(FavoritesPagination);

export { connected as FavoritesPagination };
